var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M267.3,15.5c-141.4,0-256,114.6-256,256c0,141.4,114.6,256,256,256c141.4,0,256-114.6,256-256\n\tC523.3,130.1,408.7,15.5,267.3,15.5z M323.9,228.1l-2.9,38.3h-39.3v133H232v-133h-26.5v-38.3H232v-25.7c0-11.3,0.3-28.8,8.5-39.7\n\tc8.7-11.5,20.6-19.3,41.1-19.3c33.4,0,47.4,4.8,47.4,4.8l-6.6,39.2c0,0-11-3.2-21.3-3.2c-10.3,0-19.5,3.7-19.5,14v29.9H323.9z"}));
}

SocialFacebook.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 534.7 543","style":{"enableBackground":"new 0 0 534.7 543"},"xmlSpace":"preserve"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
